import { useEffect } from "react";
import { useSearchParams } from "react-router";
import { EDITION_BTG_LINK } from "@features/banner/Edition/utils/constants";
import { useCountry } from "@hooks/useCountry";
import { useIsGooglebot } from "@hooks/useIsGooglebot";
import { IS_PLAYWRIGHT } from "@util/constant";
import Cookies from "js-cookie";

/** Hook to use to redirect BTSG Homepage to BTG homepage. */
export const useHomepageRedirect = () => {
  const { isSGUser } = useCountry();
  const isGooglebot = useIsGooglebot();
  const [searchParams] = useSearchParams();
  const isRerouteDisabled = searchParams.get("reroute") === "no";

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (isGooglebot) return;
    if (IS_PLAYWRIGHT) return;
    if (isRerouteDisabled) return;

    const userPreferredVersion = Cookies.get("preferred_region");

    if (userPreferredVersion === "SG") return;
    if (isSGUser && typeof userPreferredVersion === "undefined") return;

    const linkParams = new URLSearchParams({
      ref: "home-redirect",
    });
    const params = `?${linkParams?.toString()}`;

    const redirectUrl = `${EDITION_BTG_LINK}${params}`;
    window.location.href = redirectUrl;
  }, [isGooglebot, isSGUser, isRerouteDisabled]);
};
